import { effect, inject, LOCALE_ID, untracked } from '@angular/core';

import { forkJoin } from 'rxjs';

import { patchState, StateSignals, WritableStateSource } from '@ngrx/signals';

import { translationAdapterMethodsFactory } from './translation.adapter-methods';
import { TranslationState } from './translation.state';

type TranslationStore =
  StateSignals<TranslationState> &
  WritableStateSource<TranslationState> &
  ReturnType<typeof translationAdapterMethodsFactory>;

export const translationHooksFactory = (store: TranslationStore, localeId = inject(LOCALE_ID)) => ({
  onInit() {
    patchState(store, { currentLanguage: localeId });

    effect(() => {
      const loadedScopes = untracked(() => store._loadedScopes());

      if (store.currentLanguage() && loadedScopes.size) {
        patchState(store, { _loadedScopes: new Set() });
        untracked(() => forkJoin([...loadedScopes].map(scope => store.loadTranslations(scope))).subscribe());
      }
    });
  },
});
